var React = require('react');

function ClearFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM16.707 15.293C17.098 15.684 17.098 16.316 16.707 16.707C16.512 16.902 16.256 17 16 17C15.744 17 15.488 16.902 15.293 16.707L12 13.414L8.707 16.707C8.512 16.902 8.256 17 8 17C7.744 17 7.488 16.902 7.293 16.707C6.902 16.316 6.902 15.684 7.293 15.293L10.586 12L7.293 8.70699C6.902 8.31599 6.902 7.684 7.293 7.293C7.684 6.902 8.316 6.902 8.707 7.293L12 10.586L15.293 7.293C15.684 6.902 16.316 6.902 16.707 7.293C17.098 7.684 17.098 8.31599 16.707 8.70699L13.414 12L16.707 15.293Z","fill":"currentColor"}));
}

ClearFilled.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ClearFilled;

ClearFilled.default = ClearFilled;
